import { Routes } from "@/router/routes";
import { useNavigate } from "react-router-dom";

export function useApiError() {
  const navigate = useNavigate();

  return {
    Routes,
    navigate,
  };
}
